import type { AttributeFilterState } from '../../attribute-filter-state';

/** The fields an operator/value editor may write. */
export type OperatorValuePatch = Partial<Pick<AttributeFilterState, 'operator' | 'value' | 'value2'>>;

/** The size of a condition row's controls: small in a filter builder, medium beside full-size fields. */
export type ConditionControlSize = 'sm' | 'md';

/** The space between a row's controls: 4px between small ones, 8px between medium ones, as Ember spaces its full-size condition editor. */
export const CONDITION_CONTROL_GAP = { sm: '050', md: '100' } as const satisfies Record<ConditionControlSize, string>;

/** One autosuggest entry in a value combobox. */
export type ValueOption = { value: string; label: string };

/**
 * Autosuggest entries for a value input, from the names a query returned.
 *
 * A value is its own label on every surface — the suggestion *is* the text that
 * goes in the box — so the mapping is the same wherever the values come from,
 * and each surface differs only in which query supplied them.
 */
export function toValueOptions(values: readonly string[] | undefined): ValueOption[] {
  return (values ?? []).map((value) => ({ value, label: value }));
}
